import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  getCurrentUser,
  getOrganizationId,
  getCurrentOrganization,
  getCurrentSessionUser,
} from "@/data/store/selectors";
import { auth } from "@/data/config/firebase-config";
import { User } from "firebase/auth";

export const useAuthState = () => {
  const [authUser, setAuthUser] = useState<User | null>(
    () => auth?.currentUser || null
  );
  const [authInitialized, setAuthInitialized] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const currentUser = useSelector(getCurrentSessionUser);
  const organizationId = useSelector(getOrganizationId);
  const organization = useSelector(getCurrentOrganization);

  const setAuth = useCallback((user: User | null) => {
    setAuthUser(user);
    setAuthInitialized(true);
  }, []);



  const setDataLoadingState = useCallback((loading: boolean) => {
    setDataLoading(loading);
  }, []);

  const loading = !authInitialized || dataLoading;

  return {
    authUser,
    currentUser,
    organizationId,
    organization,
    loading,
    authInitialized,
    authLoading: !authInitialized,
    dataLoading,
    setAuth,
    setDataLoadingState,
  };
};
